import React, { useLayoutEffect, useRef } from 'react';

import { Box, Typography } from '@mui/material';
import { useGiaExamCardProperties } from 'hooks';
import { truncate } from 'lodash';
import TrimText from 'portfolio3/components/common/TrimText';

import { IGiaItem } from '../../../../api/types';
import { GiaCategoryKeys } from '../../../../const';
import { getAccentColor, NeutralColors } from '../../../../portfolio3/styles';
import ResultDoughnut from '../../../common/ResultDoughnut';

import './index.scss';

interface IExamBlockProps {
  exam: IGiaItem;
  heightModificator: number;
  setHeightModificator: React.Dispatch<React.SetStateAction<number>>;
}

const ExamBlock: React.FC<IExamBlockProps> = ({ exam, heightModificator, setHeightModificator }) => {
  const { name } = exam;
  const {
    category,
    categoryName,
    doughnutTotal,
    doughnutData,
    doughnutColor,
    resultDate,
    maxBalls,
    currentBalls,
    lowerHint,
    isCredit,
  } = useGiaExamCardProperties(exam);

  const title = name ? name : 'Не выбран';
  const categoryColor =
    category === GiaCategoryKeys.COMPULSORY ? getAccentColor('orange', '100') : NeutralColors.light_neutrals_600;
  const titleRef = useRef<any>();

  const doughnutElement = (
    <ResultDoughnut total={doughnutTotal ?? '-'} data={doughnutData} color={doughnutColor} lowerHint={lowerHint} />
  );

  const infoTitleElement = (
    <Typography ref={titleRef} component={TrimText} variant="Paragraph LG/Semi Bold">
      {truncate(title, {
        length: 20,
      })}
    </Typography>
  );

  const infoCategoryElement = (
    <Typography variant="Paragraph MD/Regular" color={categoryColor} className="exam-block__subject-category">
      {categoryName}
    </Typography>
  );

  const infoPointsScored = (
    <Typography
      variant="Paragraph MD/Regular"
      color={NeutralColors.light_neutrals_600}
      className="exam-block__subject-scores"
    >
      {currentBalls ?? 0} из {maxBalls ?? 0} <br /> первичных баллов
    </Typography>
  );

  useLayoutEffect(() => {
    const heightOffset = 24;
    // Таймаут нужен для того, чтобы высота блока высчитывалась в самый последний момент,
    // иначе высота высчитывается неправильно
    const heightModificatorTimeout = setTimeout(() => {
      const newHeightModificator = (titleRef?.current?.clientHeight - heightOffset) / heightOffset;
      if (newHeightModificator > heightModificator) setHeightModificator(newHeightModificator);
    });
    return () => {
      clearTimeout(heightModificatorTimeout);
    };
  }, [titleRef?.current, titleRef?.current?.clientHeight]);

  return (
    <Box className="pdf-exam-block pdf-keep">
      <Box className="pdf-exam-block__top">
        <Box className="pdf-exam-block__chart">{doughnutElement}</Box>
        <Box className="pdf-exam-block__info">
          {!isCredit && infoPointsScored}
          {infoTitleElement}
          {categoryName && infoCategoryElement}
        </Box>
      </Box>
      <Typography variant="Paragraph MD/Regular" color={NeutralColors.light_neutrals_600} textAlign="center">
        {resultDate}
      </Typography>
    </Box>
  );
};

export default ExamBlock;
